import { createContentHook } from './createContentHook';
import { SalesAndResourcesSimulationToolsContent } from '../types/SalesAndResourcesSimulationToolsContent';

export const useSalesAndResourcesSimulationToolsContent =
    createContentHook<SalesAndResourcesSimulationToolsContent>(
        '/SalesAndResources/SimulationTools'
    );
